// Security: Helper to validate if an origin is trusted for postMessage communication
export const isTrustedOrigin = (origin) => {
  if (!origin) return false;
  // Localhost
  if (/^http:\/\/localhost(:\d+)?$/.test(origin)) return true;
  // Production and Dev ello.ca
  if (/^https:\/\/(www\.|dev\.)?ello\.ca$/.test(origin)) return true;
  // Zoho Forms
  if (origin === 'https://forms.ciccarello.ca' || origin === 'https://forms.ello.ca') return true;
  if (/^https:\/\/forms\.zoho(public)?\.(com|ca)$/.test(origin)) return true;
  // Zoho Creator
  if (origin === 'https://creator.zoho.ca' || origin === 'https://creatorapp.zoho.ca') return true;
  // Zoho Catalyst
  if (/^https:\/\/.*\.catalystserverless\.(com|ca)$/.test(origin)) return true;
  if (/^https:\/\/.*\.zohocatalyst\.(com|ca)$/.test(origin)) return true;
  
  return false;
};

// Security: Get target origin for outgoing postMessage securely based on referrer or parent origin
export const getTargetOrigin = () => {
  try {
    // 1. Try to get parent origin directly (same-origin check)
    if (window.parent && window.parent !== window.self) {
      try {
        if (window.parent.location && window.parent.location.origin) {
          return window.parent.location.origin;
        }
      } catch (e) {
        // Cross-origin exception, fall through
      }
    }

    // 2. Check if we are in local development
    const isLocal = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' ||
                    (document.referrer && (document.referrer.indexOf('localhost') > -1 || document.referrer.indexOf('127.0.0.1') > -1));
    if (isLocal) {
      return '*';
    }

    // 3. Fallback to referrer if trusted (excluding Zoho Forms redirector)
    if (document.referrer) {
      const referrerUrl = new URL(document.referrer);
      const refOrigin = referrerUrl.origin;
      if (refOrigin !== 'https://forms.ciccarello.ca' && refOrigin !== 'https://forms.ello.ca' && isTrustedOrigin(refOrigin)) {
        return refOrigin;
      }
    }
  } catch (e) {
    console.error("Error determining target origin", e);
  }
  return "https://www.ello.ca"; // Safe fallback
};
